import { LoaderService } from 'app/services/loader.service';
import { SessionService } from 'app/services/session.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoaderGuard  {
  constructor(public sessionService: SessionService, public router: Router, private loaderService: LoaderService) {}

  canActivate(): any {
    this.loaderService.loadingContent.emit(true);
    return true;
  }
}
